<div
  class="h-screen flex flex-col bg-zinc-975 text-primary"
  [ngClass]="{
    'p-0.75': impersonating(),
    'overflow-hidden': welcome.phase() !== null,
    'bg-linear-to-b from-zinc-960 to-zinc-975':
      welcome.phase() === 'loading' || welcome.phase() === 'preview',
  }">
  <app-impersonation-banner />
  <!-- right after onboarding the app shows tilted under "Your workspace is
       ready" (app-welcome-reveal) on onboarding's background, then flips
       up from the bottom into place -->
  <app-welcome-reveal #welcome />
  <div
    [class]="shellClasses()"
    [style.--welcome-scale]="previewPose().scale"
    [style.--welcome-shift]="previewPose().shift + 'px'"
    [style.--welcome-perspective]="previewPose().perspective + 'px'">
    <app-sidebar></app-sidebar>
    <!-- Inset content shell: rounded panel on the rail-colored page background,
       8px off the top/right/bottom edges, flush against the rail. -->
    <div class="flex min-w-0 flex-1 flex-col gap-1.5 py-2 pr-2">
      <app-trial-banner />
      <div
        class="flex min-h-0 flex-1 flex-col overflow-hidden rounded-2xl bg-zinc-960">
        <header>
          <app-topbar></app-topbar>
        </header>
        <!-- the welcome preview is a picture of the page: the scrollbar is
             there but transparent, so nothing reflows when it shows.
             Route changes fade only this area (tailwind.css). -->
        <div
          class="pt-3 px-6 pb-12 overflow-y-auto flex-1 view-transition-page-content"
          [ngClass]="{
            '[scrollbar-color:transparent_transparent]':
              welcome.phase() === 'loading' || welcome.phase() === 'preview',
          }">
          <!-- Design content measure: 1152px inner width, centered -->
          <div class="mx-auto w-full max-w-6xl">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
